import * as React from "react"

function LinkedIn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={31}
      height={31}
      viewBox="0 0 31 31"
    >
      <path className={props.className} d="M15.5 0A15.5 15.5 0 110 15.5 15.507 15.507 0 0115.5 0zm-4.846 24.211v-12.1H6.63v12.1zm14.508 0v-6.942c0-3.718-1.985-5.448-4.632-5.448a4 4 0 00-3.626 2v-1.715H12.88c.053 1.136 0 12.1 0 12.1h4.02v-6.76a2.75 2.75 0 01.133-.982A2.2 2.2 0 0119.1 15c1.455 0 2.038 1.11 2.038 2.737v6.476zM8.669 6.27a2.1 2.1 0 10-.053 4.183h.026a2.1 2.1 0 10.027-4.183z" />
    </svg>
  )
}

export default LinkedIn